import React from "react";
import {useTheme, alpha, Table, Skeleton, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper} from "@mui/material";

const CustomTableLoaderComponent = ({headers, hasAction}) => {
    const theme = useTheme();

    return (
        <TableContainer component={Paper} elevation={0}  sx={{border: "1px solid #e5edf6", boxShadow: "none", borderRadius: 1}}>
            <Table>
                <TableHead sx={{backgroundColor: "inherit", color: "inherit"}}>
                    <TableRow>
                        {headers.map((header, index) => (
                            <TableCell key={index} align="start" sx={{color: theme.typography.secondary, fontWeight: 600}}>
                                {header.label || header}
                            </TableCell>
                        ))}

                        {hasAction && 
                            <TableCell align="center" sx={{color: 'inherit'}}>
                                Actions
                            </TableCell>
                        }
                    </TableRow>
                </TableHead>

                <TableBody>
                    {Array.from(new Array(6)).map((_, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {headers.map((header, cellIndex) => (
                                <TableCell key={cellIndex} align="start">
                                    <Skeleton variant="text" width="80%" sx={{backgroundColor: `${alpha(theme.palette.primary.main, 0.09)}`}} />
                                </TableCell>
                            ))}

                            {hasAction && (
                                <TableCell align="end">
                                    <Skeleton variant="text" width="80%" sx={{backgroundColor: "#eeebf8"}} />
                                </TableCell>
                            )}
                        </TableRow>
                    ))} 
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default CustomTableLoaderComponent